module.exports = __webpack_public_path__ + "img/ilustracion.04d4448f.png";